module.exports = __webpack_public_path__ + "public/media/about-pattern.png";


//////////////////
// WEBPACK FOOTER
// ./images/about-pattern.png
// module id = ./images/about-pattern.png
// module chunks = 0